export const tablePageLimits = [20, 50, 100, 150]
